import { useTranslation } from "react-i18next";

import Button from "@/components/common/Button";

const promptButtonClassName = "rounded-full border-dobu-orange text-gray-600 hover:bg-orange-100";

// "Forward to a human?" Yes/No. After a failed escalation it stays up with an error line, so Yes retries.
export function EscalationPrompt({ failed, onYes, onNo }: { failed: boolean; onYes: () => void; onNo: () => void }) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-end gap-1 p-2">
      {failed && (
        <p role="alert" className="text-sm text-red-600">
          {t("chat.escalationFailed")}
        </p>
      )}
      <div className="flex items-center justify-end gap-3">
        <Button type="button" variant="outline" className={promptButtonClassName} onClick={onYes}>
          {t("chat.escalateYes")}
        </Button>
        <Button type="button" variant="outline" className={promptButtonClassName} onClick={onNo}>
          {t("chat.escalateNo")}
        </Button>
      </div>
    </div>
  );
}
